// Placeholder — an honest "not built yet" screen.
//
// It names the screen, its build wave from screen-inventory.md §7, and says plainly that nothing
// here is implemented. A stub that looks like a real but empty screen is worse than one that says
// what it is: in this product an empty tender list reads as "there are no tenders".
export function Placeholder({ screen, wave }: { screen: string; wave: string }) {
  return (
    <div className="placeholder">
      <div className="placeholder-wave">{wave}</div>
      <h1>{screen}</h1>
      <p>
        Not built yet. This route exists so navigation and capability gating can be exercised
        end to end before the screens land.
      </p>
      <p className="placeholder-ref">
        Specification: <code>townforge/docs/screen-inventory.md</code> · build order §7
      </p>
    </div>
  )
}
